/**
 * APP/CRM guardan 0 = planta baja. En ficha se muestra texto legible;
 * Idealista Partners recibe BJ vía mapper.
 */
export function formatoAlturaPlantaCrm(valor) {
  if (valor == null || valor === "") return valor;
  const s = String(valor).trim();
  if (s === "0" || Number(s) === 0) return "Planta baja";
  return valor;
}

/** Al editar: 0 / Bajo / PB → «Planta baja» (VARCHAR en CRM). */
export function parseAlturaPlantaCrm(valor) {
  if (valor == null || valor === "") return "";
  const s = String(valor).trim();
  const low = s.toLowerCase();
  if (low === "0" || /^(planta\s*)?baj[oa]$|^pb$/.test(low)) return "Planta baja";
  return valor;
}
